import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map as rxMap, startWith } from 'rxjs/operators';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';
import { IUser } from 'Src/ng2/shared/typings/interfaces/user.interface';
import { getCurrentUser } from 'Src/ng2/store/selectors/current-user-selectors';
import { IACOption } from './../../shared/typings/interfaces/design-library.interface';
import { IPartner } from './../../shared/typings/interfaces/partner.interface';
import { PartnerPickerDataService } from './partner-picker.data.service';

@Component({
  selector: 'partner-picker',
  template: require('./partner-picker.component.html'),
  styles: [require('./partner-picker.component.scss')],
})
export class PartnerPickerComponent implements OnInit {
  filteredAcOptions$: Observable<IACOption[]>;
  isClusterAdmin$: Observable<boolean>;
  partnerType: string;
  searchInput: FormControl = new FormControl();

  constructor(
    private dataService: PartnerPickerDataService,
    private imUser: ImUser,
    private router: Router,
    private store: Store<any>,
  ) {}

  ngOnInit(): void {
    this.partnerType = this.dataService.getPartnerType(this.router.url);
    const acOptions$ = this._getAcOptions();
    const searchVal$ = this.searchInput.valueChanges.pipe(startWith(''));
    this.filteredAcOptions$ = combineLatest(acOptions$, searchVal$).pipe(
      rxMap(([acOptions, searchVal]) => this._filterAcOptions(acOptions, searchVal)),
    );
    this.isClusterAdmin$ = this.store
      .select(getCurrentUser)
      .pipe(rxMap((currentUser: IUser) => this.imUser.isClusterAdmin(currentUser, 'shelter')));
  }

  onClearInput(): void {
    this.searchInput.setValue('');
  }

  onSelectOption($e: IACOption): void {
    this.searchInput.setValue($e.human);
    this._goToPartnerPage({ partnerId: $e.key });
  }

  onManageUsers(): void {
    this._goToShelterUserPermissionsPage();
  }

  private _getAcOptions(): Observable<IACOption[]> {
    return this.dataService.getPartners(this.partnerType).pipe(
      rxMap((partners: IPartner[]) =>
        partners.map(partner => ({
          key: partner._id,
          human: `${partner.partnerName} (${partner._id})`,
        })),
      ),
    );
  }

  private _filterAcOptions(acOptions: IACOption[], value: IACOption | string): IACOption[] {
    const onSearch = typeof value === 'string';
    if (onSearch) {
      const searchTerm = (value as string).toLowerCase().trim();
      return acOptions.filter(option => {
        if (!searchTerm) {
          return true;
        }
        return option.human.toLowerCase().includes(searchTerm);
      });
    }
  }

  private _goToPartnerPage({ partnerId }): void {
    const url = `${this.partnerType}/${partnerId}`;
    this.router.navigate([url]);
  }

  private _goToShelterUserPermissionsPage(): void {
    const url = 'network/shelter/settings/user-permissions';
    this.router.navigate([url]);
  }
}
